import React from 'react';

export default function ContentLink(props) {
  return (<a className="underline hover:text-gray-400 transition-colors ease-in-out delay-250" target={props.external ? "blank_" : ""} href={props.href}>{props.anchor}</a>);
}